export const AGENDA_PAGE = () => "/agenda";
